import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import MenuIcon from "@mui/icons-material/Menu";
import PostAddIcon from "@mui/icons-material/PostAdd";
import { Button } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link as Links, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Fonts from "../../Config/Fonts";
import Icons from "../../Config/Images";
import Strings from "../../Config/Strings";
import {
  getLoggedInUserDetailsAPI,
  logOutUserAPI,
} from "../../Store/Action/UserAction";
import Colors from "../../theme/Colors";
import DeleteConfirmationPopup from "../DeleteConfirmationPopup";
import { logout } from "../../Store/Slice/authSlice";

const styles = {
  listItem: {
    height: "100%",
    padding: "15px 25px",
    alignItems: "center",
  },
  listSubItem: {
    paddingLeft: "5rem",
    alignItems: "center",
  },
  listItemText: {
    fontSize: 16,
    fontWeight: "500",
    fontFamily: Fonts.Poppins,
    color: Colors.defaultColor,
  },
  nestedItem: {
    fontSize: 16,
    fontWeight: "500",
    fontFamily: Fonts.Poppins,
    color: Colors.white,
    textAlign: "center",
  },
  nestedText: {
    fontSize: 16,
    fontWeight: "500",
    fontFamily: Fonts.Poppins,
    color: Colors.defaultColor,
  },
  nestedSubText: {
    fontSize: 14,
    fontWeight: "500",
    fontFamily: Fonts.Poppins,
    color: Colors.defaultColor,
  },
  menuButton: (isNavCollapsed) => ({
    background: "none",
    border: "none",
    cursor: "pointer",
    marginRight: "10px",
    color: Colors.white,
  }),
  leftSideContent: {
    width: "100%",
    display: "flex",
  },
  leftIcon: {
    height: 16,
    width: 16,
    objectFit: "cover",
  },
  listItemActive: {
    backgroundColor: Colors.primary, // Adjust background if needed
    color: Colors.white, // Text color white when active
  },
};

const menuItems = [
  {
    path: "/admin/dashboard",
    label: "Dashboard",
    icon: (
      <img
        src={Icons.dashboardIcon}
        style={styles.leftIcon}
        alt="dashboardIcon"
      />
    ),
  },
];

const customerItems = [
  {
    path: "/admin/userList",
    label: "Customers",
    icon: (
      <img
        src={Icons.customerIcon}
        style={styles.leftIcon}
        alt="dashboardIcon"
      />
    ),
  },
];

const manufacturesItems = [
  {
    path: "/admin/manufacturesList",
    label: "Manufacturer",
    icon: (
      <img
        src={Icons.manufacturerIcon}
        style={styles.leftIcon}
        alt="dashboardIcon"
      />
    ),
  },
];

const productItems = [
  {
    path: "/admin/productList",
    label: "Products",
    icon: (
      <img
        src={Icons.productIcon}
        style={styles.leftIcon}
        alt="dashboardIcon"
      />
    ),
  },
];

const otherItems = [
  {
    path: "/admin/orderList",
    label: "Orders",
    icon: (
      <img src={Icons.orderIcon} style={styles.leftIcon} alt="dashboardIcon" />
    ),
  },
];

const revenueItems = [
  {
    path: "/admin/RevenuePage",
    label: "Revenue",
    icon: (
      <img
        src={Icons.revenueIcon}
        style={styles.leftIcon}
        alt="dashboardIcon"
      />
    ),
  },
];

const mastersItems = [
  { path: "/admin/transport", label: "Transport" },
  { path: "/admin/productMetal", label: "Product Metal" },
  {
    path: "/admin/productPurity",
    label: "Product Purity",
  },
  {
    path: "/admin/productCategory",
    label: "Product Category",
  },
  {
    path: "/admin/rolePermissionList",
    label: "Role Permission",
  },
  {
    path: "/admin/userRolePermissionList",
    label: "User Role Permission",
  },
];

const websiteItems = [
  { path: "/admin/menu", label: "Menu", icon: <MenuIcon /> },
  { path: "/admin/page", label: "Page", icon: <PostAddIcon /> },
];

const LeftSideNav = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isProductCollapse, setIsProductCollapse] = useState(false);
  const [isMasterCollapse, setIsMasterCollapse] = useState(false);
  const [isWebsiteCollapse, setIsWebsiteCollapse] = useState(false);
  const [isNavCollapsed, setIsNavCollapsed] = useState(false); // State to manage nav collapse
  const [isLogoutOpen, setIsLogOutOpen] = useState(false);

  const { userData } = useSelector((state) => state.user);

  const handleLogOut = useCallback(() => {
    setIsLogOutOpen(!isLogoutOpen);
  }, [isLogoutOpen]);

  const handleCancelDelete = useCallback(() => {
    setIsLogOutOpen(false);
  }, []);

  useEffect(() => {
    dispatch(getLoggedInUserDetailsAPI({}));
  }, [dispatch]);

  const handleNavigation = (path) => {
    navigate(path);
    setIsProductCollapse(false);
    setIsMasterCollapse(false);
  };

  const handleProductClick = () => setIsProductCollapse(!isProductCollapse);
  const handleMastersClick = () => setIsMasterCollapse(!isMasterCollapse);
  const handleWebsiteClick = () => setIsWebsiteCollapse(!isWebsiteCollapse);
  const isActive = (path) => location?.pathname === path;

  useEffect(() => {
    setIsProductCollapse(false);
    setIsMasterCollapse(false);
  }, [location.pathname]);

  const filteredMastersItems = mastersItems.filter((item) => {
    if (
      item.path === "/admin/rolePermissionList" ||
      item.path === "/admin/userRolePermissionList" ||
      item.path === "/admin/productCategory" ||
      item.path === "/admin/productMetal" ||
      item.path === "/admin/productPurity"
    ) {
      return userData?.data[0]?.user_role_name === Strings.Admin;
    }
    return true;
  });

  const filteredWebsiteItems = websiteItems.filter((item) => {
    if (item.path === "/menu" || item.path === "/page") {
      return userData?.data[0]?.user_role_name === Strings.Admin;
    }
    return true;
  });

  const renderSubListItem = (item, nested = false) => (
    <ListItem
      button
      key={item?.path}
      onClick={() => handleNavigation(item?.path)}
      style={{
        ...styles.listSubItem,
        ...(isActive(item?.path) ? styles.listItemActive : {}),
        ...(nested ? styles.nestedItem : {}),
      }}
    >
      <p style={styles.nestedSubText}>{item.label}</p>
    </ListItem>
  );

  const renderListItem = (item, nested = false) => (
    <ListItem
      button
      key={item?.path}
      onClick={() => handleNavigation(item?.path)}
      style={{
        ...styles.listItem,
        ...(isActive(item?.path) ? styles.listItemActive : {}),
        ...(nested ? styles.nestedItem : {}),
      }}
    >
      <ListItemAvatar>
        {React.cloneElement(item?.icon, {
          style: {
            ...styles.leftIcon,
            ...(isActive(item?.path) ? { color: Colors.white } : {}), // Change icon color to white when active
          },
        })}
      </ListItemAvatar>
      <p
        style={{
          ...styles.nestedText,
          ...(isActive(item?.path) ? { color: Colors.white } : {}), // Change text color to white when active
        }}
      >
        {item.label}
      </p>
    </ListItem>
  );

  const handleLogOutAPI = useCallback(async () => {
    try {
      await dispatch(
        logOutUserAPI({}, (isSuccess, response) => {
          // setIsLogOutOpen(false);
          if (isSuccess?.status === 200) {
            dispatch(logout());
            toast.success(response?.data?.data?.message);
            navigate("/admin/login",{ state: "fromAdmin" })
          } else {
            const errorMessage =
              response?.error?.message || Strings.somethingWentWrongError;
            toast.error(errorMessage);
          }
        })
      );
    } catch (error) {
      toast.error(Strings.somethingWentWrongError);
    }
  }, []);

  return (
    <div
      style={{
        position: "sticky",
        top: "0",
        left: "0",
        zIndex: 1000,
        height: "100vh",
        overflowY: "auto",
        border: "1px solid #ccc",
        // backgroundColor: Colors.adminPrimaryColor,
        backgroundColor: "#181818",
        width: isNavCollapsed ? "60px" : "15vw", // Adjust width based on collapse state
        transition: "width 0.3s ease", // Smooth transition for collapsing
      }}
    >
      <div style={{ height: "90%" }}>
        <div className="flex flex-col h-full">
          <div
            className="flex items-center justify-start h-16 border-b px-6"
            style={{
              // display: "flex",
              // alignItems: "center",
              // justifyContent: "flex-start",
              height: "8rem",
              // padding: "0 1.5rem",
              // backgroundColor:"red",
              // textAlign:"center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#ffffff",
              fontSize: "20px",
            }}
          >
            {/* <button
              // onClick={() => setIsNavCollapsed(!isNavCollapsed)} // Toggle nav collapse
              style={styles.menuButton(isNavCollapsed)}
            >
              <img
                src={Icons.menuIcon}
                alt="menu"
                style={{ height: "24px", width: "24px", color: Colors.white }}
              />
            </button> */}
            {/* {!isNavCollapsed && (
              <Links
                className="flex items-center gap-2 font-semibold"
                to="#"
                style={{
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "10px",
                }}
              >
                <img
                  src={Icons.logoIcon}
                  alt="Logo"
                  style={{
                    height: "5vh",
                    width: "2.5vw",
                    borderRadius: "50%",
                    objectFit: "contain",
                  }}
                />
                <h2
                  style={{
                    fontSize: 45,
                    fontWeight: 700,
                    fontFamily: Fonts.NunitoSans,
                    color: Colors.white,
                    marginLeft: "10px",
                    
                  }}
                >
                  Admin
                </h2>
              </Links>
            )} */}
            <h1
              onClick={() => navigate("/admin/dashboard")}
              style={{ cursor: "pointer" }}
            >
              Admin
            </h1>
          </div>

          <nav className="flex-1 overflow-y-auto scrollbar-hide flex flex-col mt-5">
            <List sx={{ width: "100%", maxWidth: 360, marginTop: "15px" }}>
              {userData?.data?.user_role_name === Strings.Admin &&
                menuItems.map((item) => renderListItem(item))}
              {customerItems.map((item) => renderListItem(item))}
              {manufacturesItems.map((item) => renderListItem(item))}
              {productItems.map((item) => renderListItem(item))}
              {otherItems.map((item) => renderListItem(item))}
              {revenueItems.map((item) => renderListItem(item))}

              {userData?.data?.[0]?.user_role_name === Strings.Admin && (
                <>
                  <ListItem
                    button
                    onClick={handleMastersClick}
                    style={{
                      ...styles.listItem,
                      ...(isMasterCollapse ? styles.listItemActive : {}), // Ensure text color is white when collapsed
                    }}
                  >
                    <div style={styles.leftSideContent}>
                      <ListItemAvatar>
                        <img
                          src={Icons.mastersIcon}
                          style={{
                            ...styles.leftIcon,
                            ...(isMasterCollapse
                              ? { color: Colors.white }
                              : {}),
                          }} // Set icon color to white when collapsed
                          alt="dashboardIcon"
                        />
                      </ListItemAvatar>

                      <p
                        style={{
                          ...styles.listItemText,
                          ...(isMasterCollapse ? { color: Colors.white } : {}), // Set text color to white when collapsed
                        }}
                      >
                        Masters
                      </p>
                    </div>

                    {isMasterCollapse ? (
                      <ExpandLess style={{ color: Colors.white }} /> // Set ExpandLess icon color to white
                    ) : (
                      <ExpandMore style={{ color: Colors.white }} /> // Set ExpandMore icon color to white
                    )}
                  </ListItem>
                  <Collapse in={isMasterCollapse} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {filteredMastersItems.map((item) =>
                        renderSubListItem(item, true)
                      )}
                    </List>
                  </Collapse>

                  <ListItem
                    button
                    onClick={handleWebsiteClick}
                    style={{
                      ...styles.listItem,
                      ...(isWebsiteCollapse ? styles.listItemActive : {}),
                    }}
                  >
                    <div style={styles.leftSideContent}>
                      <ListItemAvatar>
                        <img
                          src={Icons.websiteIcon}
                          style={{
                            ...styles.leftIcon,
                            ...(isWebsiteCollapse
                              ? { color: Colors.white }
                              : {}),
                          }} // Set icon color to white when collapsed
                          alt="dashboardIcon"
                        />
                      </ListItemAvatar>

                      <p
                        style={{
                          ...styles.listItemText,
                          ...(isWebsiteCollapse ? { color: Colors.white } : {}), // Set text color to white when collapsed
                        }}
                      >
                        Website
                      </p>
                    </div>

                    {isWebsiteCollapse ? (
                      <ExpandLess style={{ color: Colors.white }} /> // Set ExpandLess icon color to white
                    ) : (
                      <ExpandMore style={{ color: Colors.white }} /> // Set ExpandMore icon color to white
                    )}
                  </ListItem>

                  <Collapse in={isWebsiteCollapse} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {filteredWebsiteItems.map((item) =>
                        renderSubListItem(item, true)
                      )}
                    </List>
                  </Collapse>
                </>
              )}
            </List>
          </nav>
        </div>
      </div>

      <div
        style={{
          width: "100%",
          padding: "10px 10px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button
          type="submit"
          style={{
            backgroundColor: Colors.white,
            width: "65%",
            height: "6vh",
            fontSize: 16,
            fontWeight: "500",
            fontFamily: Fonts.Poppins,
            color: Colors.red,
          }}
          onClick={handleLogOut}
        >
          <img
            src={Icons.logoutIcon}
            style={{ height: 24, width: 24, marginRight: 8 }}
            alt="deleteIcon"
          />
          {"Log Out"}
        </Button>
      </div>

      {isLogoutOpen && (
        <DeleteConfirmationPopup
          isVisible={isLogoutOpen}
          onCancel={handleCancelDelete}
          onDelete={handleLogOutAPI}
          title={Strings.logoutTitle}
          icons={Icons.logoutWithCircle}
        />
      )}
    </div>
  );
};

export default LeftSideNav;
